module.exports = __webpack_public_path__ + "media/images/training--76fd1465c90c79ae582d56c55d9120e5.png";